export default function emailValidator(message) {
    return this.test("isValidString", message, function (value) {
      const { path, createError } = this;
  
      //eslint-disable-next-line
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let valueToValidate = String(value);
      if (!regex.test(valueToValidate)) {
        return createError({ path, message });
      }
  
      return true;
    });
  }
  